import { createActionType } from 'app/store/utils';
import type {
    HEALTHY_TYPE,
    SNOWFLAKE_CONNECTION_STATUS_TYPE,
    UNHEALTHY_TYPE,
    WAREHOUSE_HEALTH_CHECK_RESULT_TYPE,
    TRIAL_PERIOD_TYPE
} from 'app/store/__generated__/types';
import type { Instant, SnowflakeConnectionStatus, WarehouseEntry } from 'app/lib/types/server';

export type Healthcheck = {
    _type: typeof HEALTHY_TYPE | typeof UNHEALTHY_TYPE | typeof TRIAL_PERIOD_TYPE;
    name:
        | 'authenticate-worker'
        | 'command-worker'
        | 'instance-active-health-check'
        | 'keycloak-user-management-health'
        | 'maintenance-mode-health-check'
        | 'query-worker'
        | 'snowflake-worker';
    elapsedTime?: number;
    message?: string;
    stackTraceAsString?: null | string;
};

export interface SnowflakeConnectionHealthcheck extends SnowflakeConnectionStatus {
    _type: typeof SNOWFLAKE_CONNECTION_STATUS_TYPE;
    name: 'snowflake-client-check';
}

export interface WarehouseHealthCheckResultEntry {
    fetchedAt: Instant;
    warehouses: WarehouseEntry[];
}

export interface WarehouseHealthCheck {
    _type: typeof WAREHOUSE_HEALTH_CHECK_RESULT_TYPE;
    name: 'warehouse-health-check';
    entries: Array<WarehouseHealthCheckResultEntry>;
}

const type = createActionType('healthcheck');

export const UPDATE_STATUS = type('UpdateStatus');
export const UPDATE_WAREHOUSE_HEALTH = type('UpdateWarehouseHealth');
export const UPDATE_SNOWFLAKE_CLIENT_STATUS = type('UpdateSnowflakeClientStatus');
export const CLEANUP_AND_UPDATE_STATUS = type('CleanupAndUpdateStatus');

export const TOGGLE_WAREHOUSE_LOAD_DIALOG = type('ToggleWarehouseLoadDialog');
